import { type Href } from 'expo-router';
import { View } from 'react-native';

import { Button } from '@/components/ui/Button';
import { BILLING_ENABLED, FREE_RUN_LIMIT, FREE_TEMPLATE_LIMIT } from '@/lib/billing';
import { SIGNUP_OPEN } from '@/lib/constants';

import { Body } from './Body';
import { Display } from './Display';
import { Eyebrow } from './Eyebrow';
import { PhoneMockup } from './PhoneMockup';
import { Section } from './Section';

export function Hero({ getStartedHref }: { getStartedHref: Href }) {
  return (
    <Section className="pb-12 pt-16">
      <View className="flex-col items-center gap-12 md:flex-row">
        {/* Copy */}
        <View className="flex-1 items-center gap-8 md:items-start">
          <View className="items-center gap-5 md:items-stretch">
            <Display className="max-w-[13ch] text-center text-[42px] leading-[1.03] tracking-[-0.025em] text-foreground md:text-left md:text-[64px]">
              Make your life repeatable.
            </Display>
            <Body className="max-w-[46ch] text-center text-lg leading-relaxed text-foreground-secondary md:text-left">
              You do complex things. Whether they&apos;re by land, sea, or air, Remove
              Before Flight helps you do them right, every time. Airplanes, boats, drones,
              CNC machines, and more.
            </Body>
            <Body className="max-w-[46ch] text-center text-lg leading-relaxed text-foreground-secondary md:text-left">
              Works and syncs across iOS, Android, and web.
            </Body>
          </View>

          <View className="flex-row flex-wrap justify-center gap-3 md:justify-start">
            {SIGNUP_OPEN ? (
              <Button size="lg" label="Start now, it's free!" href={getStartedHref} />
            ) : (
              <Button size="lg" label="Coming soon" disabled />
            )}
          </View>

          {BILLING_ENABLED ? (
            <Eyebrow className="text-xs tracking-[0.14em] text-faint">
              Free for {FREE_TEMPLATE_LIMIT} checklists &amp; {FREE_RUN_LIMIT} runs · no
              card
            </Eyebrow>
          ) : null}
        </View>

        {/* Phone mockup */}
        <View className="flex-none">
          <PhoneMockup />
        </View>
      </View>
    </Section>
  );
}
